export class AnimationNames {
	public static readonly GENERIC_BUTTON: IAnimationNamesObject = {
		Name: {
			IDLE: 'IDLE',
			HOVER: 'HOVER',
			CLICK: 'CLICK',
		},
		Mix: {},
	};

	public static readonly MAIN_MENU: IAnimationNamesObject = {
		Name: {
			IDLE_VISIBLE: 'IDLE',
			IDLE_HIDDEN: 'HIDDEN',
			ENTER: 'BACKGROUND_POPUP',
			EXIT: 'BACKGROUND_EXIT',
		},
		Mix: {},
	};

	public static readonly SETTINGS_CONFIG_TOGGLE: IAnimationNamesObject = {
		Name: {
			ACTIVE: 'SETTINGS_BUTTON_ACTIVE_IDLE', // The toggle animation
			INACTIVE: 'SETTINGS_BUTTON_IDLE',
			ACTIVATED: 'SETTINGS_BUTTON_ACTIVE',
		},
		Mix: {},
	};
}

export class IAnimationNamesObject {
	// Animations and their stringnames.
	public Name: {
		[key: string]: string;
	};
	// Animations and their mixing values.
	public Mix: {
		[key: string]: [string, number];
	};
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/animations/AnimationNames.ts